function pad(value) {
  return String(value).padStart(2, "0");
}

function toIcsStamp(date, time) {
  const [year, month, day] = String(date).split("-");
  const [hour, minute] = String(time || "09:00").split(":");
  return `${year}${pad(month)}${pad(day)}T${pad(hour)}${pad(minute)}00`;
}

export function buildIcs(event) {
  const start = toIcsStamp(event.date, event.time);
  const uid = event.id || crypto.randomUUID();
  const desc = [event.description, event.notes].filter(Boolean).join("\\n");
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//DreamHome Journey//Calendar//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${uid}@dreamhome.local`,
    `DTSTAMP:${start}`,
    `DTSTART:${start}`,
    `SUMMARY:${(event.title || "Appointment").replace(/\n/g, " ")}`,
    event.location ? `LOCATION:${event.location.replace(/\n/g, " ")}` : "",
    desc ? `DESCRIPTION:${desc}` : "",
    "END:VEVENT",
    "END:VCALENDAR",
  ]
    .filter(Boolean)
    .join("\r\n");
}

export function downloadIcs(event) {
  const blob = new Blob([buildIcs(event)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${(event.title || "event").replace(/[^\w]+/g, "-")}.ics`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function emailEvent(event) {
  const subject = encodeURIComponent(event.title || "Calendar event");
  const body = encodeURIComponent(
    [
      event.title,
      `${event.date || ""} ${event.time || ""}`.trim(),
      event.location ? `Location: ${event.location}` : "",
      event.contactName ? `Contact: ${event.contactName}` : "",
      event.description || "",
      event.notes || "",
    ]
      .filter(Boolean)
      .join("\n")
  );
  window.location.href = `mailto:?subject=${subject}&body=${body}`;
}
